module.exports = __webpack_public_path__ + "img/twitter.83bbcc8e.svg";